export const ExceptionKind = {
    CANCEL: 'CANCEL',
    MOVE: 'MOVE',
    REPLACE_ROOM: 'REPLACE_ROOM',
    REPLACE_TEACHER: 'REPLACE_TEACHER',
};
/** Значення в порядку оголошення в схемі. */
export const EXCEPTION_KIND_VALUES = ['CANCEL', 'MOVE', 'REPLACE_ROOM', 'REPLACE_TEACHER'];
export const EXCEPTION_KIND_LABELS = {
    CANCEL: 'Скасування',
    MOVE: 'Перенесення',
    REPLACE_ROOM: 'Заміна аудиторії',
    REPLACE_TEACHER: 'Заміна викладача',
};
export const EXCEPTION_KIND_TONES = {
    CANCEL: 'danger',
    MOVE: 'warning',
    REPLACE_ROOM: 'info',
    REPLACE_TEACHER: 'info',
};
//# sourceMappingURL=exception-kind.js.map